import React from 'react';
import { Mail } from 'lucide-react';
import { Modal } from '../ui/Modal';
import { pillSecondary } from '../ui/pills';
import { AdminNotificationSettings, type GroupeEmails } from './AdminNotificationSettings';
import { EmailMotDePasseOublie } from './EmailMotDePasseOublie';

/**
 * Le bouton « Emails » d'un écran d'administration, et la fenêtre qu'il ouvre.
 *
 * Les modèles de courriel du super admin vivaient tous dans Paramètres > Notifications : une liste de
 * seize blocs qu'on n'allait consulter qu'en sachant déjà qu'elle existait. Ils sont maintenant rangés
 * dans l'écran où ils se déclenchent — les courriels de comptes dans Gestion Clients, ceux du support
 * dans le Support, celui des automatisations dans son écran.
 */
const TITRES: Record<GroupeEmails, { titre: string; sousTitre: string }> = {
    clients: {
        titre: 'Emails des comptes clients',
        sousTitre: "Création de compte, mots de passe, collaborateurs et demandes d'inscription.",
    },
    support: {
        titre: 'Emails du support',
        sousTitre: 'Ce que reçoit le client quand vous répondez, et ce que vous recevez quand il écrit.',
    },
    automatisation: {
        titre: "Emails des demandes d'automatisation",
        sousTitre: "Ce que vous recevez quand un client demande la connexion d'une plateforme de réservation.",
    },
};

export function EmailsDuModule({ groupe }: { groupe: GroupeEmails }) {
    const [ouvert, setOuvert] = React.useState(false);
    const { titre, sousTitre } = TITRES[groupe];

    return (
        <>
            <button type="button" onClick={() => setOuvert(true)} className={pillSecondary(34)} title={titre}>
                <Mail size={14} /> Emails
            </button>
            {ouvert && (
                <Modal open={ouvert} onClose={() => setOuvert(false)} size="2xl" title={titre} subtitle={sousTitre}>
                    {/* Le seul e-mail que la personne déclenche elle-même : réglé ici, avec les autres e-mails de mot de passe. */}
                    {groupe === 'clients' && <div className="mb-6 max-w-3xl"><EmailMotDePasseOublie /></div>}
                    <AdminNotificationSettings groupe={groupe} />
                </Modal>
            )}
        </>
    );
}
